const labels: Record<string, string> = {
  // Estados do chamado e níveis
  draft: 'Rascunho', open: 'Aberto', triage: 'Em triagem', waiting_approval: 'Aguardando aprovação',
  waiting_service: 'Aguardando atendimento', in_service: 'Em atendimento', waiting_requester: 'Aguardando solicitante',
  waiting_collaborator: 'Aguardando colaborador', waiting_vendor: 'Aguardando fornecedor', transfer_pending: 'Transferência pendente',
  resolved: 'Resolvido', reopened: 'Reaberto', rejected: 'Rejeitado', cancelled: 'Cancelado', closed: 'Encerrado',
  low: 'Baixa', medium: 'Média', high: 'Alta', critical: 'Crítica',

  // Interações, visibilidade e classificação
  message: 'Mensagem', correction: 'Correção', request_information: 'Solicitação de informação',
  provide_information: 'Informação fornecida', clarification: 'Esclarecimento',
  public: 'Pública', internal: 'Interna', confidential: 'Confidencial', restricted: 'Restrita',

  // SLA
  first_response: 'Primeira resposta', resolution: 'Resolução', running: 'Em andamento', paused: 'Pausado',
  met: 'Atendido', breached: 'Violado',

  // Aprovação
  all: 'Todos', quorum: 'Quórum', any: 'Qualquer aprovador', pending: 'Pendente', approved: 'Aprovado',
  returned: 'Devolvido', impediment: 'Impedimento', opinion: 'Parecer técnico',

  // Acesso
  create: 'Concessão', change: 'Alteração', revoke: 'Revogação', regular: 'Regular', special: 'Especial',
  privileged: 'Privilegiado', temporary: 'Temporário', emergency: 'Emergencial', provisioned: 'Provisionado',
  revocation_pending: 'Revogação pendente', active: 'Ativo', inactive: 'Inativo', succeeded: 'Concluída', failed: 'Falhou',

  // Ativos
  in_use: 'Em uso', available: 'Disponível', in_maintenance: 'Em manutenção', on_loan: 'Emprestado',
  retired: 'Baixado', not_found: 'Não localizado', physical: 'Físico', software: 'Software',
  requested: 'Solicitada', waiting_acceptance: 'Aguardando confirmações', ready: 'Pronta para execução',
  executing: 'Em execução', executed: 'Executada', delivery: 'Entrega', replacement: 'Substituição',
  maintenance_start: 'Envio para manutenção', maintenance_finish: 'Conclusão da manutenção', return: 'Devolução',
  loss: 'Perda', damage: 'Dano', theft: 'Furto ou roubo', missing: 'Não localizado', transfer: 'Transferência', recovery: 'Recuperação',
  remote_lock: 'Bloqueio remoto', completed: 'Concluída',

  // Notificações e anexos
  in_app: 'Central interna', email: 'E-mail', teams: 'Microsoft Teams', delivered: 'Entregue',
  dead_letter: 'Falha definitiva', queued: 'Na fila', retrying: 'Nova tentativa',
  pending_scan: 'Aguardando verificação', clean: 'Verificado', quarantined: 'Em quarentena',

  // Relatórios
  tickets: 'Chamados', sla: 'SLA', satisfaction: 'Satisfação', processing: 'Gerando', expired: 'Expirado',
  text: 'Texto', textarea: 'Texto longo', number: 'Número', boolean: 'Sim ou não', select: 'Lista de opções', date: 'Data',

  // Papéis
  agent: 'Agente', triager: 'Triador', manager: 'Gestor', admin: 'Administrador', requester: 'Solicitante', collaborator: 'Colaborador', vendor: 'Fornecedor',
};

const fieldLabels: Record<string, string> = {
  impact: 'Impacto', urgency: 'Urgência', description: 'Descrição', details: 'Detalhes', summary: 'Resumo',
  followupreason: 'Motivo do acompanhamento', follow_up_reason: 'Motivo do acompanhamento',
  justification: 'Justificativa', system: 'Sistema', event: 'Ocorrência', location: 'Localização',
  reason: 'Motivo', title: 'Título', category: 'Categoria', priority: 'Prioridade', beneficiary: 'Beneficiário',
  dueat: 'Prazo', validuntil: 'Válido até', profile: 'Perfil', scope: 'Escopo',
};

const eventLabels: Record<string, string> = {
  'ticket.draft_created': 'Rascunho criado', 'ticket.draft_updated': 'Rascunho atualizado',
  'ticket.submitted': 'Chamado enviado', 'ticket.updated': 'Chamado atualizado', 'ticket.viewed': 'Chamado visualizado',
  'ticket.operational_viewed': 'Chamado visualizado pelo atendimento', 'ticket.message_added': 'Mensagem adicionada',
  'ticket.information_requested': 'Informação solicitada', 'ticket.information_provided': 'Informação fornecida',
  'ticket.collaboration_added': 'Colaborador incluído', 'ticket.claimed': 'Chamado assumido',
  'ticket.assigned': 'Responsável definido', 'ticket.reclassified': 'Chamado reclassificado',
  'ticket.service_started': 'Atendimento iniciado', 'ticket.waiting': 'Chamado colocado em espera',
  'ticket.resumed': 'Atendimento retomado', 'ticket.transfer_requested': 'Transferência solicitada',
  'ticket.transfer_accepted': 'Transferência aceita', 'ticket.transfer_rejected': 'Transferência recusada',
  'ticket.resolved': 'Solução registrada', 'ticket.solution_confirmed': 'Solução confirmada',
  'ticket.solution_contested': 'Solução contestada', 'ticket.clarification_requested': 'Esclarecimento solicitado',
  'ticket.closed': 'Chamado encerrado', 'ticket.auto_closed': 'Chamado encerrado automaticamente',
  'ticket.reopened': 'Chamado reaberto', 'ticket.follow_up_created': 'Chamado de acompanhamento criado',
  'ticket.follow_up_linked': 'Chamado de acompanhamento vinculado', 'ticket.cancellation_requested': 'Cancelamento solicitado',
  'ticket.cancelled': 'Chamado cancelado', 'ticket.rejected': 'Chamado rejeitado',
  'ticket.attachment_uploaded': 'Anexo enviado', 'ticket.attachment_downloaded': 'Anexo baixado',
  'ticket.attachment_removed': 'Anexo removido', 'ticket.sla_warning': 'Alerta de SLA',
  'ticket.sla_breached': 'SLA violado', 'ticket.satisfaction_answered': 'Pesquisa de satisfação respondida',
  'ticket.demo_seeded': 'Massa de teste carregada',
  'approval.pending': 'Aprovação pendente', 'approval.approved': 'Aprovação concluída',
  'approval.rejected': 'Aprovação rejeitada', 'approval.returned': 'Aprovação devolvida',
  'approval.invalidated': 'Aprovação invalidada', 'approval.advanced': 'Aprovação avançou de etapa',
  'access.request_created': 'Solicitação de acesso criada', 'access.request_changed': 'Solicitação de acesso alterada',
  'access.provisioned': 'Acesso provisionado', 'access.revoked': 'Acesso revogado',
  'access.extension_requested': 'Prorrogação de acesso solicitada', 'access.revocation_due': 'Revogação de acesso pendente',
  'asset.operation_requested': 'Operação patrimonial solicitada', 'asset.operation_executed': 'Operação patrimonial executada',
  'asset.incident_reported': 'Ocorrência patrimonial registrada', 'asset.containment_added': 'Contenção adicionada',
  'asset.containment_completed': 'Contenção concluída', 'asset.transfer_confirmation': 'Transferência patrimonial confirmada',
  'asset.transfer_rejected': 'Transferência patrimonial recusada',
  'report.requested': 'Relatório solicitado', 'report.generated': 'Relatório gerado',
  'report.downloaded': 'Relatório baixado', 'report.schedule_created': 'Agendamento de relatório criado',
};

const entityLabels: Record<string, string> = {
  cau_ticket: 'Chamado', ticket: 'Chamado', cau_approval: 'Aprovação', approval: 'Aprovação',
  cau_access_request: 'Solicitação de acesso', access_request: 'Solicitação de acesso',
  cau_asset_operation: 'Operação patrimonial', asset_operation: 'Operação patrimonial',
  cau_report_job: 'Relatório', report: 'Relatório', service: 'Serviço', queue: 'Fila',
};

export function cauLabel(value: string | null | undefined): string {
  if (!value) return '—';
  return labels[value.toLowerCase()] ?? humanize(value);
}

export function cauFieldLabel(key: string, fields?: Array<{ key: string; label: string }>): string {
  const configured = fields?.find((field) => field.key === key)?.label;
  if (configured) return translateKnownField(configured);
  return translateKnownField(key);
}

export function cauEventLabel(event: string): string {
  return eventLabels[event] ?? humanize(event.replace(/^ticket\.|^approval\.|^access\.|^asset\.|^report\./, ''));
}

export function cauEntityLabel(entity: string): string {
  return entityLabels[entity] ?? humanize(entity);
}

export function cauValueLabel(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
  if (Array.isArray(value)) return value.map(cauValueLabel).join(', ');
  if (typeof value === 'object') return Object.entries(value as Record<string, unknown>)
    .map(([key, item]) => `${cauFieldLabel(key)}: ${cauValueLabel(item)}`).join('; ');
  if (typeof value === 'string' && labels[value.toLowerCase()]) return labels[value.toLowerCase()];
  return String(value);
}

function translateKnownField(value: string): string {
  const normalized = value.replace(/[\s-]/g, '').toLowerCase();
  return fieldLabels[normalized] ?? fieldLabels[value.toLowerCase()] ?? humanize(value);
}

function humanize(value: string): string {
  const text = value.replace(/[._-]+/g, ' ').replace(/([a-z\d])([A-Z])/g, '$1 $2').trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : value;
}

